import {NgUserService} from "../../../ng-shared/ng-services/ng-user.service";
import {
    ITCIEnvToolsAgentCreateMenuInput, ITCIEnvToolsAgentCreateMenuOutput,
    ITCIEnvToolsAgentMenuOutput,
    ITCIEnvToolsAgentMenuInput,
    TCITenantComponentInput,
    TCITenantComponentOutput,
} from "../../../ng-tenant/tci-tenant-components";
import {
    APPLICATION_SCOPE_TYPE,
    ITCIAppFeatureService,
    ITCIApplication,
    ITCIApplicationAuth,
    ITCITenantComponentOptions,
    ITCIUserInfo,
    TCI_AGENT_CREATE_TYPE,
    TCI_SUPPLEMENT_MENU_TYPE,
    TCITenantAppType
} from "@tci/common";
import {Observable} from "rxjs";

/**
 *  This for the filter menu component input
 */
export class BaseEnvToolsSupplementMenuComponentInput
    extends TCITenantComponentInput
    implements ITCIEnvToolsAgentMenuInput {
    /**
     *
     * @param userService
     * @param featureToggleService
     * @param filterOption
     * @param selection
     */
    constructor(
        private userService: NgUserService,
        private featureToggleService: ITCIAppFeatureService,
        private filterOption: ITCITenantComponentOptions<TCI_SUPPLEMENT_MENU_TYPE>) {
        super();
        const tenantTypes = filterOption.getTenantTypes();
        this.tenantAppType = tenantTypes.length > 0 ? TCITenantAppType.createPseudoTenant(...tenantTypes) : tenantTypes[0];
    }

    getFilterOption(): ITCITenantComponentOptions<TCI_SUPPLEMENT_MENU_TYPE> {
        return this.filterOption;
    }


    getApplication(): ITCIApplication {
        return null;
    }

    getAuthForFunction(scope: APPLICATION_SCOPE_TYPE | string): Observable<ITCIApplicationAuth> {
        return this.userService.getAuthForFunction(scope);
    }

    getUserInfo(): Observable<ITCIUserInfo> {
        return this.userService.getUserInfo(false);
    }

    getFeatureToggleService(): ITCIAppFeatureService {
        return this.featureToggleService;
    }
}

export class BaseEnvToolsSupplementMenuComponentOutput<E extends ITCIEnvToolsAgentMenuOutput> extends TCITenantComponentOutput<E> {
    constructor() {
        super();
    }
}

/**
 *
 */
export class BaseEnvToolsSupplementCreateMenuComponentInput extends TCITenantComponentInput {
    /**
     *
     * @param userService
     * @param featureToggleService
     * @param filterOption
     * @param selection
     */
    constructor(
        private userService: NgUserService,
        private featureToggleService: ITCIAppFeatureService,
        private filterOption: ITCITenantComponentOptions<TCI_SUPPLEMENT_MENU_TYPE>) {
        super();
        const tenantTypes = filterOption.getTenantTypes();
        this.tenantAppType = tenantTypes.length > 0 ? TCITenantAppType.createPseudoTenant(...tenantTypes) : tenantTypes[0];

    }

    getFilterOption(): ITCITenantComponentOptions<TCI_SUPPLEMENT_MENU_TYPE> {
        return this.filterOption;
    }

    getApplication(): ITCIApplication {
        return null;
    }

    getAuthForFunction(scope: APPLICATION_SCOPE_TYPE | string): Observable<ITCIApplicationAuth> {
        return this.userService.getAuthForFunction(scope);
    }

    getUserInfo(): Observable<ITCIUserInfo> {
        return this.userService.getUserInfo(false);
    }

    getFeatureToggleService(): ITCIAppFeatureService {
        return this.featureToggleService;
    }
}

export class BaseEnvToolsSupplementCreateMenuComponentOutput<E extends ITCIEnvToolsAgentCreateMenuOutput>
    extends TCITenantComponentOutput<E> {
    constructor() {
        super();
    }
}
